// Riesgos.jsx
import React, { useState } from "react";
import {
    Table,
    Input,
    Select,
    Space,
    Tag,
    Typography,
    Row,
    Col,
    Card,
    Tooltip,
    message,
    Button,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import NuevoRiesgoModal from "./NuevoRiesgoModal";

const { Search } = Input;
const { Option } = Select;
const { Title } = Typography;

// Datos demo iniciales
const dataRiesgosBase = [
    {
        key: 1,
        tipo: "Riesgos Operacionales (DPS)",
        descripcion:
            "Paros, huelgas, asonadas, extorsiones, actos terroristas de grupos al margen de la Ley, combates u operativos de la fuerza pública en los territorios donde interviene el programa.",
        especificar: "",
        responsable: "Coordinador General",
        estado: "En curso",
        fechaInicio: "",
        fechaSolucion: "",
        observaciones: "",
        diasSolucion: "",
        departamento: "",
        municipio: "",
        proveedor: "",
        quienReporta: "Hernán Rodríguez",
    },
    {
        key: 2,
        tipo: "Riesgos de la Naturaleza (DPS)",
        descripcion: "Fenómenos climáticos severos o desastres naturales.",
        especificar: "",
        responsable: "Coordinador General",
        estado: "Implementado",
        fechaInicio: "",
        fechaSolucion: "",
        observaciones: "",
        diasSolucion: "",
        departamento: "",
        municipio: "",
        proveedor: "",
        quienReporta: "",
    },
    {
        key: 3,
        tipo: "Riesgos Económicos (DPS)",
        descripcion: "Desabastecimiento de insumos requeridos.",
        especificar: "",
        responsable: "Coordinador General",
        estado: "Implementado",
        quienReporta: "",
    },
    {
        key: 4,
        tipo: "Transporte y accesos viales",
        descripcion: "Restricciones de tránsito en vías terciarias.",
        responsable: "Líder de logística y Compras",
        estado: "En curso",
        quienReporta: "",
    },
    {
        key: 5,
        tipo: "Auditoría y cumplimiento",
        descripcion:
            "Soportes incompletos o inconsistencias documentales detectadas en auditorías.",
        responsable: "Coordinador Municipal",
        estado: "Implementado",
        quienReporta: "",
    },
];

const Riesgos = () => {
    const [busqueda, setBusqueda] = useState("");
    const [estadoFiltro, setEstadoFiltro] = useState(null);
    const [tipoFiltro, setTipoFiltro] = useState(null);

    // Estado del modal y de la data
    const [open, setOpen] = useState(false);
    const [data, setData] = useState(dataRiesgosBase);

    const estados = ["En curso", "Implementado", "Cerrado"];
    const tipos = [...new Set(data.map((r) => r.tipo).filter(Boolean))];

    const handleAdd = (values) => {
        const next = {
            key: Date.now(),
            ...values,
        };
        setData((prev) => [next, ...prev]);
        message.success("Riesgo registrado");
        setOpen(false);
    };

    const filtrarDatos = () => {
        return data.filter((item) => {
            const coincideBusqueda =
                busqueda === "" ||
                Object.values(item || {})
                    .join(" ")
                    .toLowerCase()
                    .includes(busqueda.toLowerCase());
            const coincideEstado = !estadoFiltro || item.estado === estadoFiltro;
            const coincideTipo = !tipoFiltro || item.tipo === tipoFiltro;
            return coincideBusqueda && coincideEstado && coincideTipo;
        });
    };

    const columns = [
        {
            title: "Estado",
            dataIndex: "estado",
            key: "estado",
            width: 140,
            filters: estados.map((e) => ({ text: e, value: e })),
            onFilter: (value, record) => record.estado === value,
            render: (estado) => (
                <Tag color={estado === "Implementado" ? "green" : estado === "Cerrado" ? "blue" : "orange"}>
                    {estado || "-"}
                </Tag>
            ),
        },
        {
            title: "Tipo de riesgo",
            dataIndex: "tipo",
            key: "tipo",
            filters: tipos.map((t) => ({ text: t, value: t })),
            onFilter: (value, record) => record.tipo === value,
            sorter: (a, b) => (a.tipo || "").localeCompare(b.tipo || ""),
            width: 260,
        },
        {
            title: "Descripción del riesgo",
            dataIndex: "descripcion",
            key: "descripcion",
            width: 360,
            ellipsis: true,
            render: (text) => (
                <Tooltip placement="topLeft" title={text}>
                    <span>
                        {text && text.length > 80 ? text.substring(0, 80) + "..." : text || "-"}
                    </span>
                </Tooltip>
            ),
        },
        {
            title: "Responsable",
            dataIndex: "responsable",
            key: "responsable",
            width: 220,
        },
        {
            title: "Quien reporta",
            dataIndex: "quienReporta",
            key: "quienReporta",
            width: 220,
        },
    ];

    return (
        <>


            <Card style={{ margin: 16, padding: 16 }}>
                <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
                    <Col>
                        <Title level={4} style={{ margin: 0 }}>Gestión de Riesgos</Title>
                    </Col>
                    <Col>
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => setOpen(true)}
                        >
                            Nuevo Riesgo
                        </Button>
                    </Col>
                </Row>
                <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
                    <Col xs={24} sm={12} md={8}>
                        <Search
                            placeholder="Buscar en todos los campos"
                            allowClear
                            onChange={(e) => setBusqueda(e.target.value)}
                            value={busqueda}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={8}>
                        <Select
                            placeholder="Filtrar por Estado"
                            allowClear
                            style={{ width: "100%" }}
                            value={estadoFiltro}
                            onChange={setEstadoFiltro}
                        >
                            {estados.map((e) => (
                                <Option key={e} value={e}>
                                    {e}
                                </Option>
                            ))}
                        </Select>
                    </Col>
                    <Col xs={24} sm={12} md={8}>
                        <Select
                            placeholder="Filtrar por Tipo de riesgo"
                            allowClear
                            style={{ width: "100%" }}
                            value={tipoFiltro}
                            onChange={setTipoFiltro}
                            showSearch
                        >
                            {tipos.map((t) => (
                                <Option key={t} value={t}>
                                    {t}
                                </Option>
                            ))}
                        </Select>
                    </Col>
                </Row>

                <Table
                    columns={columns}
                    dataSource={filtrarDatos()}
                    pagination={{ pageSize: 6 }}
                    scroll={{ x: true }}
                    bordered
                    size="middle"
                />
            </Card>

            {/* Modal hijo para crear/editar */}
            <NuevoRiesgoModal
                open={open}
                onClose={() => setOpen(false)}
                onSubmit={handleAdd}
            />
        </>
    );
};

export default Riesgos;
